<lib-modal
  [visible]="visible()"
  [title]="'requirements.testCases.pickerTitle' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="'requirements.testCases.pickerConfirm' | translate: { count: selectedCount() }"
  [cancelText]="'requirements.testCases.pickerCancel' | translate"
  [disabled]="busy() || !hasSelection()"
  (save)="onConfirm()"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #content>
  <div class="tcp">
    <p class="tcp__subtitle">
      {{ 'requirements.testCases.pickerSubtitle' | translate: { count: selectedCount() } }}
    </p>

    <div class="tcp__search">
      <mat-icon class="tcp__search-icon" aria-hidden="true">search</mat-icon>
      <input
        class="tcp__search-input"
        type="text"
        [value]="search()"
        (input)="onSearchInput($event)"
        [placeholder]="'requirements.testCases.pickerSearch' | translate"
      />
    </div>

    <div class="tcp__filters">
      <button
        type="button"
        class="dropdown-chip"
        [class.dropdown-chip--active]="typeFilter() !== null"
        [matMenuTriggerFor]="typeMenu"
      >
        @if (typeFilter()) {
          {{ 'testCases.type.' + typeFilter() | translate }}
        } @else {
          {{ 'requirements.testCases.filter.type' | translate }}
        }
        <span class="dropdown-chip__caret" aria-hidden="true">▾</span>
      </button>
      <mat-menu #typeMenu="matMenu">
        <button mat-menu-item (click)="setType(null)">
          {{ 'requirements.testCases.filter.allTypes' | translate }}
        </button>
        @for (opt of typeOptions(); track opt) {
          <button mat-menu-item (click)="setType(opt)">{{ 'testCases.type.' + opt | translate }}</button>
        }
      </mat-menu>

      <button
        type="button"
        class="dropdown-chip"
        [class.dropdown-chip--active]="priorityFilter() !== null"
        [matMenuTriggerFor]="priorityMenu"
      >
        @if (priorityFilter()) {
          {{ 'testCases.priority.' + priorityFilter() | translate }}
        } @else {
          {{ 'requirements.testCases.filter.priority' | translate }}
        }
        <span class="dropdown-chip__caret" aria-hidden="true">▾</span>
      </button>
      <mat-menu #priorityMenu="matMenu">
        <button mat-menu-item (click)="setPriority(null)">
          {{ 'requirements.testCases.filter.allPriorities' | translate }}
        </button>
        @for (opt of priorityOptions(); track opt) {
          <button mat-menu-item (click)="setPriority(opt)">{{ 'testCases.priority.' + opt | translate }}</button>
        }
      </mat-menu>

      <app-saved-testcase-filter-chips
        [filters]="savedFilters()"
        [activeName]="activeFilterName()"
        [canSave]="canSaveFilter()"
        (filterSaved)="onFilterSaved($event)"
        (filterSelected)="onFilterSelected($event)"
        (filterDeleted)="onFilterDeleted($event)"
      />
    </div>

    @if (filtered().length === 0) {
      <p class="tcp__empty">
        {{
          (testCases().length === 0 ? 'requirements.testCases.noneAvailable' : 'requirements.testCases.noResults')
            | translate
        }}
      </p>
    } @else {
      <div class="tcp__list" role="listbox" aria-multiselectable="true">
        @for (tc of filtered(); track tc.id) {
          <div
            class="tcp__row"
            [class.tcp__row--selected]="isSelected(tc.id)"
            role="option"
            [attr.aria-selected]="isSelected(tc.id)"
            tabindex="0"
            (click)="toggleSelect(tc)"
            (keydown.enter)="toggleSelect(tc)"
            (keydown.space)="toggleSelect(tc); $event.preventDefault()"
          >
            <mat-checkbox
              [checked]="isSelected(tc.id)"
              [attr.aria-label]="tc.title"
              (click)="$event.stopPropagation()"
              (change)="toggleSelect(tc)"
            ></mat-checkbox>
            @if (tc.automationKey) {
              <span class="tcp__badge">{{ tc.automationKey }}</span>
            }
            <span class="tcp__title">{{ tc.title }}</span>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
